import {
  createOrder,
  createStripeOrder,
  retryOrder,
  retryStripeOrder,
  getOrderPayload,
  checkoutStripeOrder,
  getOrderRedirectUrl,
  getStripeOrderRedirectUrl,
  getStripeOrder,
  getOrder,
} from '@portal/kit/pkg/services'
import { redirectToBank } from '@portal/kit/pkg/helpers'

import { DEFAULT_PAYMENT_BACKEND, PAYMENT_BACKENDS } from 'helpers/constants'

export const getPaymentBackend = (portalConfiguration) =>
  portalConfiguration?.payment_backend || DEFAULT_PAYMENT_BACKEND

export const isStripePayment = (portalConfiguration) =>
  [PAYMENT_BACKENDS.STRIPE_WIFIRST_AGORA, PAYMENT_BACKENDS.STRIPE_WIFIRST].includes(getPaymentBackend(portalConfiguration))

// Sogenactif et Stripe sont exposés par le même service avec des signatures
// identiques. On résout ici l'implémentation à utiliser selon le payment_backend
// de la configuration du portail (cf. isStripePayment).
const paymentServices = (isStripe) => ({
  createOrder: isStripe ? createStripeOrder : createOrder,
  retryOrder: isStripe ? retryStripeOrder : retryOrder,
  getOrderPayload: isStripe ? checkoutStripeOrder : getOrderPayload,
  getOrderRedirectUrl: isStripe ? getStripeOrderRedirectUrl : getOrderRedirectUrl,
  getOrder: isStripe ? getStripeOrder : getOrder
})

// Stripe renvoie une URL de checkout, Sogenactif un formulaire à poster vers la banque
export const redirectToPayment = (isStripe, data) => {
  if (isStripe) {
    window.location.replace(data.bank_url)
  } else {
    redirectToBank(data)
  }
}

// Chemins de retour (relatifs) envoyés au backend, qui substitue :order_id
export const offerPaths = (offerId) => ({
  checkout: `/offers/${offerId}/checkout`,
  confirmation: `/offers/${offerId}/confirmation/:order_id`,
  confirmationInProgress: `/offers/${offerId}/confirmation-in-progress/:order_id`,
})

export default paymentServices
